module.exports = __webpack_public_path__ + "img/icon-square-kebab.ac5313cd.svg";